//AUTOGENERATED BY build-with-ilastik-overlay
export const ILASTIK_URL='https://app.ilastik.org/';
